
import { Directive, TemplateRef, ViewContainerRef, OnInit, Input } from '@angular/core';
import { LoaderService } from '../services/loader.service';
import { WHITE_LIST_APIS } from '@app/shared/http-interceptors/whitelisted-apis';
import { HttpRequest } from 'selenium-webdriver/http';

@Directive({
  selector: '[appDisplayLoader]'
})
export class DisplayLoaderDirective implements OnInit {
  whitelistAPIs: any = [];
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private loaderService: LoaderService
  ) { this.whitelistAPIs = WHITE_LIST_APIS; }

  condition: boolean;
  prevCondition: boolean = false;

  ngOnInit() {

    this.loaderService.status.subscribe((val: boolean) => {

      if (val && this.condition || !val && !this.condition) {
        if (this.prevCondition !== val) {
          this.prevCondition = val;
          this.viewContainer.createEmbeddedView(this.templateRef);
        }
      } else {
        if (this.prevCondition !== val) {
          this.prevCondition = val;
          this.viewContainer.clear();
        }
      }
    });
  }

  @Input() set appDisplayLoader(condition: boolean) {
    this.condition = condition;
  }


}



// WEBPACK FOOTER //
// ./src/app/shared/directives/display-loader.directive.ts